import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { Website } from '@dbk/ui-icons';
import { LoadingCircle } from '../../components/common/loading';
import CalendarModal from '../../components/common/calendar-modal';
import SimpleDate from '../../components/common/date';
import format from 'date-fns/format';
import { DatePicker } from '@dbk/ui-datepicker';
import moment from 'moment';
import { excelDownload, jsonToXml } from '../../utils/excel-download';
var languageCode = 'en';

class DownloadsPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      downloadType: '',
      value: {
        from: moment(this.props.downloads.startDate),
        to: moment(this.props.downloads.endDate),
      }
    };
    this.callDirectExcelService = this.callDirectExcelService.bind(this);
  }

  handleOnChange = (range) => {
    this.setState({
      value: {
        ...this.state.value,
        ...range
      }
    })
  }
  onApply = () => {
    this.props.onApply(this.state.value);
  }

  afterDateSelection() {
    const {
      downloads: { startDate, endDate, isDateBarClickable, calendar },
      i18n: { messages },
    } = this.props;
    let completeDate;
    if (startDate == endDate) {
      completeDate = (
        <div>
          {' '}
          {
            messages[
            'app.maturities.dateSelectionBar.currentlyShowing.singleLanguage'
            ]
          }{' '}
          <SimpleDate value={format(startDate, 'DD MMMM YYYY')} />
        </div>
      );
    } else if (
      startDate != undefined &&
      startDate.length != 0 &&
      endDate != undefined &&
      endDate.length != 0
    ) {
      completeDate = (
        <div>
          {' '}
          {
            messages[
            'app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage'
            ]
          }{' '}
          <SimpleDate value={format(startDate, 'DD MMMM YYYY')} />{' '}
          {messages['app.common.to']}{' '}
          <SimpleDate value={format(endDate, 'DD MMMM YYYY')} />
        </div>
      );
    }

    return (
      <div>
        <div className="downloadButtonContainer">
          <Button className="downloadButton" onClick={() => this.callDirectExcelService('Transaction')}>
            {messages['app.downloads.download']}
          </Button>
        </div>
      </div>
    );
  }

  transactionDownloads() {
    let noSelectDate = false;
    let afterSelectDate = false;
    const {
      i18n: { messages },
      downloads: { calendar, isDateBarClickable },
    } = this.props;
    if (isDateBarClickable) {
      noSelectDate = true;
      afterSelectDate = true;
    }

    if (this.props.auth.langCode && this.props.auth.langCode != null) {
      languageCode = this.props.auth.langCode.toLowerCase();
    }

    return (

      <div className="transactionDownload">
        <Large secondary className="datePickerBorder">
          {messages['app.downloads.transDown']}
        </Large>
        <View>
          <DatePicker
            enableYearNavigation
            enableRangeSelection
            onChange={this.handleOnChange}
            value={this.state.value}
            startDate={moment().subtract(1, 'year')}
            endDate={moment()}
            selectionStart={this.state.value.from}
            selectionEnd={this.state.value.to}
            onApply={this.onApply}
          />

          {afterSelectDate && this.afterDateSelection()}
        </View>
      </div>
    );
  }

  positionDownloads() {
    const { i18n: { messages } } = this.props;
    return (
      <View className="positionDownload">
        <Large secondary>{messages['app.downloads.positnDown']}</Large>
        <div className="downloadButtonContainer">
          <Button className="downloadButton" onClick={() => this.callDirectExcelService('Positions')}>
            {messages['app.downloads.download']}
          </Button>
        </div>
      </View>
    );
  }

  // JSONToCSV(JSONData, ReportTitle) {
  //   var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
  //   var CSV = '';
  //   var row = '';
  //   for (var index1 in arrData.sections) {
  //     CSV += arrData.sections[index1].name + '\r\n\n';
  //     CSV += arrData.sections[index1].description + '\r\n\n';

  //     for (var index in arrData.sections[index1].headers) {
  //       row += arrData.sections[index1].headers[index] + ',';
  //     }
  //     row = row.slice(0, -1);
  //     CSV += row + '\r\n';
  //     for (var i = 0; i < arrData.sections[index1].results.length; i++) {
  //       var row = '';
  //       for (var index in arrData.sections[index1].results[i]) {
  //         row += '"' + arrData.sections[index1].results[i][index] + '",';
  //       }
  //       row.slice(0, row.length - 1);
  //       CSV += row + '\r\n';
  //     }
  //   }
  //   if (CSV == '') {
  //     alert('Invalid data');
  //     return;
  //   }
  //   if (ReportTitle == 'Positions') {
  //     ReportTitle = 'Portfolios';
  //   }
  //   var fileName = '';
  //   fileName += ReportTitle.replace(/ /g, '_');

  //   var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
  //   var anchor = document.createElement('a');
  //   anchor.href = uri;

  //   anchor.style = 'visibility:hidden';
  //   anchor.download = fileName + '.csv';

  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // }

  // createXmlHeader(arrData) {
  //   let headerRow = '<ss:Row>\n';
  //   let dataRow = '';

  //   for (var preRow in arrData.sections) {
  //     dataRow +=
  //       '<ss:Row>' +
  //       '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
  //       arrData.sections[preRow].name +
  //       '</ss:Data>' +
  //       '</ss:Cell>' +
  //       '</ss:Row>\n' +
  //       '<ss:Row>' +
  //       '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
  //       arrData.sections[preRow].description +
  //       '</ss:Data>' +
  //       '</ss:Cell>' +
  //       '</ss:Row>\n';
  //     for (var index in arrData.sections[preRow].headers) {
  //       headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
  //       headerRow += '    <ss:Data ss:Type="String">';
  //       headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
  //       headerRow += '  </ss:Cell >\n';
  //     }
  //   }

  //   headerRow += '</ss:Row>\n';
  //   return (
  //     '<?xml version="1.0"?>\n' +
  //     '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
  //     '<ss:Styles>\n' +
  //     '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
  //     '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
  //     '<ss:Borders>\n' +
  //     '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
  //     '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
  //     '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
  //     '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
  //     '</ss:Borders>\n' +
  //     '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
  //     '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
  //     '</ss:Style>\n' +
  //     '</ss:Styles>\n' +
  //     '<ss:Worksheet ss:Name="Sheet1">\n' +
  //     '<ss:Table>\n' +
  //     dataRow +
  //     '<ss:Row/>\n' +
  //     headerRow
  //   );
  // }

  // createXmlFooter() {
  //   return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
  // }

  // jsonToXml(jsonObject) {
  //   var row;
  //   var col;
  //   var xml;
  //   var arrData =
  //     typeof jsonObject != 'object' ? JSON.parse(jsonObject) : jsonObject;

  //   xml = this.createXmlHeader(arrData);

  //   for (var rowData in arrData.sections) {
  //     for (
  //       var resultsLength = 0;
  //       resultsLength < arrData.sections[rowData].results.length;
  //       resultsLength++
  //     ) {
  //       xml += '<ss:Row>\n';
  //       for (var col in arrData.sections[rowData].results[resultsLength]) {
  //         xml += '  <ss:Cell>\n';
  //         xml += '    <ss:Data ss:Type="String">';
  //         xml +=
  //           arrData.sections[rowData].results[resultsLength][col] +
  //           '</ss:Data>\n';
  //         xml += '  </ss:Cell>\n';
  //       }
  //       xml += '</ss:Row>\n';
  //     }
  //   }
  //   xml += this.createXmlFooter();
  //   return xml;
  // }

  // excelDownload(content, filename, contentType) {
  //   if (!contentType) contentType = 'application/octet-stream';
  //   var anchor = document.createElement('a');
  //   var blob = new Blob([content], {
  //     type: contentType,
  //   });
  //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //     window.navigator.msSaveOrOpenBlob(blob, filename + '.xls');
  //   } else {
  //     anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
  //     anchor.download = filename + '.xls';
  //   }
  //   anchor.style.display = 'none';
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // }

  componentWillReceiveProps(nextProps) {
    if (this.props.downloads.result != nextProps.downloads.result) {
      const result = nextProps.downloads.result;
      excelDownload(
        jsonToXml(result),
        this.state.downloadType,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      this.setState({ isLoading: false });
    }
  }
  callDirectExcelService(trxType) {
    this.setState({ isLoading: true });
    const {
      settings: { currentEnvironment: { remoteUrl } },
      downloads: { startDate, endDate },
      selectedPortfolioData,
      i18n: { messages },
    } = this.props;
    this.setState({ downloadType: trxType });
    this.props.downloads
      .downLoadReport({
        reportname: trxType,
        fromDate: startDate,
        toDate: endDate,
      })
      .then((success) => { });
  }

  render() {
    const { profile, auth, i18n: { messages } } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };
    const { isLoading } = this.state;

    auth.resetInfoMessage();
    return (

      <div>


        <div className="row small-12 large-12 medium-12">
          <H1 secondary>{messages[
            'app.common.downloads'
          ]}</H1>
          <div>
            <div className="downloadContainer">
              <div className="column large-6 medium-6 small-6">
                {this.positionDownloads()}
              </div>
              <div className="column large-6 medium-6 small-6">
                {this.transactionDownloads()}
              </div>
            </div>
            {isLoading && <LoadingCircle />}
          </div>
        </div>

      </div>
    );
  }

  componentWillUnmount() {
    // this.props.downloads.setEmpty('');
    // this.props.downloads.setFalse(false);
    this.props.clearDownloadDates();
  }
}

DownloadsPage.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  downloads: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
  settings: PropTypes.shape({
    currentEnvironment: PropTypes.shape({
      remoteUrl: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    userId: PropTypes.string,
    authHeader: PropTypes.string,
    lastSession: PropTypes.string,
  }),
  app: PropTypes.shape({
    user: PropTypes.shape({
      selectedPortfolioData: PropTypes.string,
    }),
  }),
  rsa: PropTypes.shape({
    rsaAuthorised: PropTypes.bool,
  }),
};

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      downloads: {
        calendar: {
          open: {
            $call: 'open',
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        isDateBarClickable: true,
        setFalse: { $set: 'isDateBarClickable' },
        setStartDateEmpty: { $set: 'startDate' },
        setEndDateEmpty: { $set: 'endDate' },
        downLoadReport: { $call: 'excelData' },
        result: true,
      },
      resetDownloadDates: { $call: 'downloads.resetDates' },
      clearDownloadDates: { $call: 'downloads.clearDates' },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      settings: {
        currentEnvironment: {
          remoteUrl: true,
        },
      },
      rsaChangePage: { $call: 'rsa.changePage' },
      auth: {
        userId: true,
        resetInfoMessage: { $call: 'resetInfoMessage' },
        lastSession: true,
        authHeader: true,
        langCode: true,
      },
      app: {
        user: {
          selectedPortfolioData: true,
        },
      },
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
      onApply: {
        $call: 'downloads.onCalendarDone'
      }
    },
  },
  ({ app, ...queries }) => ({
    selectedPortfolioData: app.user.selectedPortfolioData,
    ...queries,
  })
)(DownloadsPage);

export { DownloadsPage };